import { Button, Tooltip } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import ScrapingService from "../../services/scraping.service";
import React, { useState } from "react";

export default function DownloadMevFile({ filename, expedientId, link }) {

    const [loading, setLoading] = useState(false);
    const [isDownloadHovered, setIsDownloadHovered] = useState(false);
    const handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setLoading(true);
        ScrapingService.downloadMevAttachment({ link, filename, expedientId })
            .then(blob => {
                const link_1 = document.createElement("a");
                link_1.href = URL.createObjectURL(blob);
                link_1.download = `${filename}.pdf`;
                document.body.appendChild(link_1);
                link_1.click();
                document.body.removeChild(link_1);
                window.URL.revokeObjectURL(link_1.href);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <Tooltip title="Descargar MEV">
            <Button type="link" icon={
                <DownloadOutlined
                onMouseEnter={() => setIsDownloadHovered(true)}
                onMouseLeave={() => setIsDownloadHovered(false)}
                style={{
                  color: isDownloadHovered ? "#0185F8" : "#002A4E",
                  fontSize: "17px"
                }}
              />
            } onClick={handleClick} loading={loading} />
        </Tooltip>
    );
}